import { memo } from "react";
import { useAppSelector } from "stores";
import { getAppState } from "stores/modules/app.state/selectors";

export type Size = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

const SelectingArea = ({
  selectingAreaSize,
}: {
  selectingAreaSize: Size | null;
}) => {
  const isMultiSelectMode = useAppSelector((state) =>
    getAppState(state, "isMultiSelectMode")
  );

  if (!isMultiSelectMode || !selectingAreaSize) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: selectingAreaSize.left,
        top: selectingAreaSize.top,
        width: selectingAreaSize.right - selectingAreaSize.left,
        height: selectingAreaSize.bottom - selectingAreaSize.top,
        border: "1px solid #fff",
        background: "rgba(96, 165, 250, 0.18)",
        pointerEvents: "none",
        zIndex: 1000,
      }}
    />
  );
};

export default memo(SelectingArea);
